function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import CircularProgress from '@material-ui/core/CircularProgress';
import styled from 'styled-components';
import { TabWrapper, StyledUserLevelCard, StyledTabPanel, StyledAppbar } from '../Application/ApplicationStyle';
import RecommendationBreadcrumbs from '../Breadcrumbs/RecommendationBreadCrumbs';
import OverallRisk from '../OverallRisk/OverallRisk';
import RecommendationAccordion from './RecommendationAccordion';
import { useSelector } from 'react-redux';
import Card from '@material-ui/core/Card';
import StatusCard from '../StatusCard/StatusCard';
import Grid from '@material-ui/core/Grid';
import AccessGraph from '../access-graph/access-graph';

function TabPanel(props) {
  const {
    children,
    value,
    index,
    ...other
  } = props;
  return /*#__PURE__*/React.createElement(StyledTabPanel, _extends({
    role: "tabpanel",
    hidden: value !== index,
    id: `scrollable-auto-tabpanel-${index}`,
    "aria-labelledby": `scrollable-auto-tab-${index}`
  }, other), value === index && /*#__PURE__*/React.createElement("div", {
    style: {
      padding: '0px',
      height: '100%'
    }
  }, children));
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`
  };
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    padding: 10,
    width: '100%',
    backgroundColor: theme.palette.background.paper
  },
  gridMargin: {
    marginBottom: '1px'
  },
  title: {
    fontSize: '12px',
    fontFamily: 'OpenSans-Regular',
    lineHeight: '12px',
    color: '#202020',
    paddingLeft: '21px'
  },
  userNameContainer: {
    marginTop: '16px',
    marginBottom: '16px'
  },
  userName: {
    color: '#292929',
    fontFamily: 'OpenSans-Regular',
    fontSize: '20px',
    fontWeight: 600,
    display: 'inline',
    marginRight: '3px',
    marginLeft: '21px'
  },
  cardRoot: {
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0
  }
}));
const StyledTabs = withStyles({
  root: {
    margin: '0px 27px'
  },
  indicator: {
    backgroundColor: '#1A98F8',
    height: '4px'
  },
  flexContainer: {
    borderBottom: '4px solid #F0F5FA'
  }
})(props => /*#__PURE__*/React.createElement(Tabs, _extends({}, props, {
  TabIndicatorProps: {
    children: /*#__PURE__*/React.createElement("span", null)
  }
})));
const StyledTab = withStyles(theme => ({
  root: {
    textTransform: 'none',
    color: '#313131',
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: '13px',
    fontFamily: 'OpenSans-Regular',
    minWidth: '0px',
    padding: '0px',
    marginLeft: '13px',
    marginRight: '20px',
    opacity: 1,
    '&:focus': {
      opacity: 1,
      fontWeight: 500
    }
  },
  selected: {
    color: '#1A98F8'
  }
}))(props => /*#__PURE__*/React.createElement(Tab, _extends({
  disableRipple: true
}, props)));
export const SpinnerDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export default function RecommendationTabs({
  isLoading = false,
  overallTrendLoading,
  handleOverallTrendLoading,
  ResourceDistributionData
}) {
  const showRecommendationTab = useSelector(state => state.recommendationTable.showRecommendationTab);
  const dataDoughnut = useSelector(state => state.recommendationDataSlice.dataDoughnut);
  const dataLine = useSelector(state => state.entityTrendLine.dataLine);
  const policyData = useSelector(state => state.accordionData.policy);
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const selectedApplication = useSelector(state => state.applicationDrillChart.selectedApplication);
  let statuCardData = [];

  if (selectedApplication) {
    statuCardData = useSelector(state => state.DetailsPageStatusCard.statusData);
  } else {
    statuCardData = useSelector(state => state.RiskScoreCard.statusData);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: classes.root,
    style: {
      background: '#F3F2F1'
    }
  }, /*#__PURE__*/React.createElement(RecommendationBreadcrumbs, null), isLoading ? /*#__PURE__*/React.createElement(SpinnerDiv, null, /*#__PURE__*/React.createElement(CircularProgress, null)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 0,
    className: classes.gridMargin
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 6
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.userNameContainer
  }, /*#__PURE__*/React.createElement("h2", {
    className: classes.userName
  }, policyData.objectName), /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, "Entity Type:", ' ', policyData.objectType === 'UserAccount' ? 'User Account' : policyData.objectType))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 6
  }, /*#__PURE__*/React.createElement(StatusCard, {
    statuCardData: statuCardData
  }))), /*#__PURE__*/React.createElement(StyledUserLevelCard, null, /*#__PURE__*/React.createElement(StyledAppbar, null, /*#__PURE__*/React.createElement(TabWrapper, null, /*#__PURE__*/React.createElement(Card, {
    className: classes.cardRoot
  }, /*#__PURE__*/React.createElement(StyledTabs, {
    value: value,
    onChange: handleChange
  }, /*#__PURE__*/React.createElement(StyledTab, _extends({
    label: "Overview"
  }, a11yProps(0))), /*#__PURE__*/React.createElement(StyledTab, _extends({
    label: "Recommendations"
  }, a11yProps(1))), /*#__PURE__*/React.createElement(StyledTab, _extends({
    label: "Access Map"
  }, a11yProps(2))))), /*#__PURE__*/React.createElement(TabPanel, {
    value: value,
    index: 0,
    style: {
      backgroundColor: 'white'
    }
  }, /*#__PURE__*/React.createElement(OverallRisk, {
    showRecommendationTab: showRecommendationTab,
    doughnutData: dataDoughnut,
    trendLineData: dataLine,
    overallTrendLoading: overallTrendLoading,
    handleOverallTrendLoading: handleOverallTrendLoading,
    ResourceDistributionData: ResourceDistributionData,
    riskLabel: "Risk Score",
    recommendationTab: true
  })), /*#__PURE__*/React.createElement(TabPanel, {
    value: value,
    index: 1,
    style: {
      backgroundColor: 'white'
    }
  }, /*#__PURE__*/React.createElement(RecommendationAccordion, null)), /*#__PURE__*/React.createElement(TabPanel, {
    value: value,
    index: 2,
    style: {
      backgroundColor: 'white'
    }
  }, /*#__PURE__*/React.createElement(AccessGraph, null)))))));
}